import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url, filter) =>
  await AxiosConfig.create('put', url).call(filter).getResponseData();

function usePatchNote(filter) {
  const { data, _error, isLoading, isValidating, mutate } = useSWR(
    `/patchnote/`,
    (url) => fetcher(url, filter),
    {
      refreshInterval: 0,
      revalidateOnFocus: true,
    }
  );

  return {
    patchNotes: data,
    isLoading: isLoading,
    isValidating: isValidating,
    mutate: mutate,
  };
}

export default usePatchNote;
